<template>
  <TextTransformInput v-bind="$attrs" />
</template>

<script>
import TextTransformInput from './text-transform-input'
export default {
  name: 'V2TextTransformInput',
  components: { TextTransformInput }
}
</script>
